export default __webpack_public_path__ + "ee875d3307cf05b02069e6eb5954989d.png";